import { isNil, pickBy } from "lodash";
import configService from "../services/config/config-service";
import type { IAdditionalContactInfo } from "../onboarding/types/onboard.types";

export function fakePromise<T>(mockData: T) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockData);
    }, 2000);
  });
}
export const hasShopifyContext = () => {
  const apiKey = configService.appConfig.shopifyApiKey;
  const host = new URLSearchParams(globalThis.location.search).get("host");
  return Boolean(apiKey) && Boolean(host);
};

export const delay = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));

export const isLocalEnv =
  configService.appConfig.environment === "local" ||
  globalThis.location.hostname === "localhost" ||
  globalThis.location.hostname === "127.0.0.1";

export const sessionTokenFailedExceptionBaseMessage = "Session token failed:";

// Removes entries with null, undefined, empty string, or empty array values from an object.
export const cleanObject = <T extends object>(obj: T): Partial<T> => {
  return pickBy(
    obj,
    (v) =>
      !isNil(v) && // removes null + undefined
      v !== "" && // removes empty strings
      !(Array.isArray(v) && v.length === 0), // removes empty arrays
  );
};

export const normalizeAdditionalContactInformations = (
  additionalContactInformations: IAdditionalContactInfo[] | null,
): IAdditionalContactInfo[] | null => {
  if (isNil(additionalContactInformations))
    return additionalContactInformations;

  const allEmpty = additionalContactInformations.every(
    (obj) => Object.keys(cleanObject(obj)).length === 0,
  );

  return allEmpty ? null : additionalContactInformations;
};

export const toPostData = (obj: object): Record<string, unknown> =>
  obj as Record<string, unknown>;

interface SourceObj {
  name: string;
  code: string;
}
interface IGetNameFromCode {
  code: string;
  sourceArray: SourceObj[];
}
export const getNameFromCode = (params: IGetNameFromCode) => {
  const { code, sourceArray } = params;
  const resultObj = sourceArray?.find(
    (sourceObj: SourceObj) => sourceObj.code === code,
  );
  return resultObj?.name || code;
};
